import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IReservationCustomer } from '../model/reservation-customer.model';
import { SERVER_API_URL } from '../../../app.constants';
import { createRequestOption } from '../../util/request-util';

type EntityResponseType = HttpResponse<IReservationCustomer>;
type EntityArrayResponseType = HttpResponse<IReservationCustomer[]>;

@Injectable({ providedIn: 'root' })
export class ReservationCustomerService {
  public resourceUrl = SERVER_API_URL + 'api/reservation-customers';
  public reportUrl = SERVER_API_URL + 'api/report/jasper/reservation-customers'

  constructor(protected http: HttpClient) {}

  create(reservationCustomer: IReservationCustomer): Observable<EntityResponseType> {
    return this.http.post<IReservationCustomer>(this.resourceUrl, reservationCustomer, {
      observe: 'response',
    });
  }

  update(reservationCustomer: IReservationCustomer): Observable<EntityResponseType> {
    return this.http.put<IReservationCustomer>(this.resourceUrl, reservationCustomer, {
      observe: 'response',
    });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IReservationCustomer>(`${this.resourceUrl}/${id}`, {
      observe: 'response',
    });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IReservationCustomer[]>(this.resourceUrl, {
      params: options,
      observe: 'response',
    });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  getJoined(dateFrom: number, dateTo: number, status: number): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.resourceUrl + '/get-joined/' + dateFrom + '/' + dateTo + '/' + status,
      { observe: 'response' }
    );
  }

  downloadJoinedPdf(dateFrom: number, dateTo: number, status: number):  Observable<Blob>  {
    const url = this.reportUrl + '/get-joined/' + dateFrom + '/' + dateTo + '/' + status;
    return this.http.post(url, null, {
      responseType: 'blob',
    });
  }

  downloadJoinedCustomerPdf(dateFrom: number, dateTo: number, status: number):  Observable<Blob>  {
    const url = this.reportUrl + '/get-joined-customer/' + dateFrom + '/' + dateTo + '/' + status;
    return this.http.post(url, null, {
      responseType: 'blob',
    });
  }

  getJoinedCustomer(
    dateFrom: number,
    dateTo: number,
    status: number
  ): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.resourceUrl + '/get-joined-customer/' + dateFrom + '/' + dateTo + '/' + status,
      { observe: 'response' }
    );
  }

  getJoinedCustomerAndResource(
    dateFrom: number,
    dateTo: number,
    status: number,
    resourceSearch: string
  ): Observable<HttpResponse<any>> {
    if (resourceSearch === undefined || resourceSearch === null || resourceSearch.trim() === '')
      resourceSearch = '-1';
    return this.http.get<any>(
      this.resourceUrl +
        '/get-joined-customer-resource/' +
        dateFrom +
        '/' +
        dateTo +
        '/' +
        status +
        '/' +
        resourceSearch,
      { observe: 'response' }
    );
  }
}
